import { AlertCircle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

/**
 * ADO #700: chip rendered next to a modified key field whose reason has
 * been dismissed without saving. Clicking the badge re-opens the reason
 * popover so the operator can supply (or retry) the justification.
 */
export interface MissingFeedbackBadgeProps {
  readonly label?: string;
  onClick(): void;
}

export function MissingFeedbackBadge(props: MissingFeedbackBadgeProps): JSX.Element {
  const label = props.label ?? 'Feedback needed';
  return (
    <Badge
      variant="warning"
      role="button"
      tabIndex={0}
      className="cursor-pointer gap-1 text-[10px] font-medium"
      onClick={props.onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          props.onClick();
        }
      }}
      aria-label={`${label} — click to add a reason`}
    >
      <AlertCircle className="h-3 w-3" />
      {label}
    </Badge>
  );
}
